<template>
  <b-container class="pl-0 pr-0 pt-0 pb-0">
    <b-row v-if="loading">
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
    <b-row v-show="!loading">
      <b-col class="text-left">
        <b-form-group 
          id="gpcSessionGroup"
          breakpoint="md"
          label="GPC Session"
          label-for="gpcselect"
          :horizontal="horizontal"
          validated
        >
          <b-form-select :options="sessions" v-model="session" class="mb-3" id="gpcselect" :required="required" @input="selectionMade($event)" />    
        </b-form-group>
      </b-col>
    </b-row>        
  </b-container>
</template>
<script>
import * as API from '@/services/API';
import moment from 'moment';

export default {
  name: 'GPCSessionSelection',
  // properties you can pass to this component
  props: {
    customer: {
      default: null,
      type: Number
    },
    horizontal: false,
    required: true,
    value: null,
    gpcId: null
  },
  watch: {
    customer: {
      handler(newData) {
        this.filter();
      }
    }
  },
  // this is reactive data and will be updated in the view
  data () {
    return {
      sessions: [],
      session: null,
      allSessions: [],
      loading: false
    };
  },
  created () {
    this.fetchData();
  },
  methods: {
    filter() {
      this.sessions = this.allSessions.filter(x => !this.customer || x.customer.id === this.customer)
        .map(session => ({text: `${session.customer.name} - ${moment(session.session_date.replace('T',' ')).format('DD MMM YYYY')}`, value: session}));
      this.sessions.unshift({text: 'Select GPC Session', value: null});
      this.session = this.allSessions.filter(x => x.id === this.gpcId)[0];
    },
    fetchData () {
      this.loading = true
      return API.searchGPCSessions({}).then(res => {
        // convert data to something our dropdown can work it
        this.allSessions = res.body.results;
        this.filter();
        this.loading = false
      });
    },
    selectionMade () {
      this.$emit('input', this.session);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GPCSessionSelection.vue